import React, { useEffect, useState } from "react";
import { InverterDetail, MainSliderApi } from "../../../../../api/Api";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi';
// import "./Tab5Content.css";
import { Fullscreen, Refresh } from "@mui/icons-material"; // Import icons
import IconButton from "@mui/material/IconButton";
// import UpdateInverter from "./UpdateInverter";
import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { MaxDemandApi } from "../../../../../api/Api";


export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 7);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

export default function MaxDemandMisLog({ ID, TabTitle }) {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const [logData, setLogData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // State for filtered data
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
    const [offlineCount, setOfflineCount] = useState(0);
    const [onlineCount, setOnlineCount] = useState(0);

    const [showOfflineOnly, setShowOfflineOnly] = useState(false); // Offlien filter state
    const [showOnlineOnly, setShowOnlineOnly] = useState(false); // Offlien filter state
    // this is modal code
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const now = new Date();
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const [credentials2] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        LOC_CODE: localStorage.getItem("LCODE") || "",

    });


    // const rowsPerPage = 15;

    const credentials = {
        USER_ID: localStorage.getItem("LoginID"),
        PLANT_code: localStorage.getItem("LCODE"),
        pass_key: "XYZ321",
        MTR: ID,
        DT1: StartDate,
        DT2: EndDate
    };
    console.log("credentialsmax", credentials)

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await MaxDemandApi(credentials);

            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
                setFilteredData(res.data); // Initialize filtered data
            } else {
                setLogData([]);
                setFilteredData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    // console.log("logdatamax",logData)
useEffect(() => {
    fetchLogData();
}, [StartDate, EndDate, ID]);

    // correct image

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials2.LOGIN_ID}&LOC_CODE=${credentials2.LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const handleSearch = () => {
        const filtered = logData.filter((item) => {
            return (
                Object.values(item)
                    .join(" ")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
        });
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to the first page
    };





    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;



    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const tableHeaders = [
        { label: "SN", key: "sn" },
        { label: "ID", key: "MTR" },
        { label: "Date", key: "DATET" },
        { label: "Day", key: "DAY" },
        { label: "NAME", key: "NAME" },
        { label: "kWh Cumulative", key: "KWH_CUM" },
        { label: "kWh Consumption", key: "ENG" },
        { label: "Peak kW", key: "KW_MAX" },
        { label: "Date Time[kW]", key: "KW_MAX_DATE" },
        { label: "Time[kW]", key: "KW_MAX_TIME" },
        { label: "kVAh Cumulative", key: "KVAH_CUM" },
        { label: "kVAh Consumption", key: "ENG_KVAH" },
        { label: "Peak kVA", key: "KVA_MAX" },

        { label: "Date Time[kVA]", key: "KVA_MAX_DATE" },
        { label: "Time[kVA]", key: "KVA_MAX_TIME" },

    ];


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // This code for update modal

    const handleOpenModal = (userData) => {
        setSelectedUser(userData);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    const handleUpdate = (updatedUser) => {
        setLogData((prevData) =>
            prevData.map((user) =>
                user.USER_ID === updatedUser.USER_ID ? updatedUser : user
            )
        );
        handleClose();
    };


    //offline and online
    // offline and online filter
    useEffect(() => {
        let updatedData = logData;

        if (showOfflineOnly) {
            // Show only TOT_GEN = 0
            updatedData = updatedData.filter(item =>
                Number(item.KW) === 0
            );
        }

        if (showOnlineOnly) {
            // Show only TOT_GEN ≠ 0
            updatedData = updatedData.filter(item =>
                Number(item.KW) !== 0
            );
        }

        setFilteredData(updatedData); // ✅ Update table rows
        setCurrentPage(1); // ✅ Go back to first page after filter
    }, [showOfflineOnly, logData, showOnlineOnly]);



    useEffect(() => {
        const count = logData.filter(item =>
            Number(item.KW) === 0
        ).length;
        setOfflineCount(count);
    }, [logData]);



    useEffect(() => {
        const count = logData.filter(item =>
            Number(item.KW) !== 0
        ).length;
        setOnlineCount(count);
    }, [logData]);




    const exportToExcel = async () => {
        const exportData = logData.map((item, index) => {
            let row = {};
            tableHeaders.forEach((header) => {
                if (header.key === "sn") {
                    row[header.label] = index + 1; // Serial number
                } else {
                    row[header.label] = item[header.key] ?? "";
                }
            });
            return row;
        });

        await ExportExcel(
            ImageUrl,
            exportData,
            "", // Start Date if needed
            "", // End Date if needed
            `Inverter_Details`, // File name
            LoggedInUserInfo
        );
    };

    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };


    return (

        <>
            <div className="w-100 my-1 ">
                <div className="row">
                    <div className="col-md-12" >
                        {loading && <p>Loading...</p>}
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        <div
                            className="w-100"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderBottom: "2px solid #dee2e6",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center px-3">
                                <h6
                                    style={{
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: "#343a40",
                                    }}
                                >

                                    &nbsp;&nbsp;
                                    <select
                                        id="entries"
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(Number(e.target.value));

                                        }}
                                    >
                                        <option value={10}>10</option>

                                        <option value={20}>20</option>

                                        <option value={logData.length}>All</option>
                                    </select>
                                    <span style={{ marginLeft: '8px' }}>entries</span>

                                </h6>




                                <div className="d-flex align-items-center">
                                    {/* <button
                                        className="btn btn-danger mx-1"
                                        onClick={() => {
                                            setShowOfflineOnly(true);  // ✅ Correctly enable offline filter
                                            setShowOnlineOnly(false)
                                        }}
                                        style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                    >
                                        Offline [{offlineCount}]

                                    </button>

                                    <button
                                        className="btn btn-success mx-1"
                                        onClick={() => {
                                            setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                            setShowOnlineOnly(true)
                                        }}
                                        style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                    >
                                        Online [{onlineCount}]

                                    </button> */}

                                    <label>
                                        From:&nbsp;
                                        <input
                                            type="date"
                                            value={StartDate} // Use StartDate directly
                                            onChange={(e) => handleStartDateChange(e.target.value)}
                                            style={{
                                                padding: "2px 2px",
                                                borderRadius: "14px",
                                                border: "1px solid #ccc",
                                            }}
                                        />
                                    </label>
                                    <label>
                                        To:&nbsp;
                                        <input
                                            type="date"
                                            value={EndDate} // Use EndDate directly
                                            onChange={(e) => handleEndDateChange(e.target.value)}
                                            style={{
                                                padding: "2px 2px",
                                                borderRadius: "14px",
                                                border: "1px solid #ccc",
                                            }}
                                        />
                                    </label>
                                    {/* Search Input */}
                                    <input
                                        type="text"
                                        className="form-control form-control-sm me-2"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ maxWidth: "200px", height: "2.3rem" }}
                                    />

                                    <button
                                        className="btn btn-primary btn-sm"
                                        style={{ padding: ".41rem", fontSize: ".8rem", borderRadius: "1rem" }}
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>&nbsp; &nbsp;


                                    <button onClick={exportToExcel} className='export-button' style={{ padding: ".41rem", fontSize: ".8rem", borderRadius: "1rem" }}>Excel</button>

                                    {/* Refresh Button */}
                                    <IconButton onClick={fetchLogData}>
                                        <Refresh />
                                    </IconButton>


                                </div>
                            </div>
                        </div>

                        <div
                            className="table-responsive"
                            style={{
                                border: "1px solid #dee2e6",
                                borderTop: "none",
                            }}
                        >
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ color: "#356E35" }}>SN</th>
                                        <th style={{ color: "#356E35" }}>ID</th>
                                        <th style={{ color: "#356E35" }}>DATE</th>
                                        <th style={{ color: "#356E35" }}>DAY</th>
                                        <th style={{ color: "#356E35" }}>NAME</th>

                                        <th style={{ color: "#356E35" }}>kWh CUMULATIVE</th>
                                        <th style={{ color: "#356E35" }}>kWh CONSUMPTION</th>

                                        <th style={{ color: "#356E35" }}>PEAK kW</th>
                                        <th style={{ color: "#356E35" }}>DATE TIME [kW]</th>
                                        <th style={{ color: "#356E35" }}>TIME [kW]</th>

                                        <th style={{ color: "#356E35" }}>kVAh CUMULATIVE</th>
                                        <th style={{ color: "#356E35" }}>kVAh CONSUMPTION</th>

                                        <th style={{ color: "#356E35" }}>PEAK kVA</th>
                                        <th style={{ color: "#356E35" }}>DATE TIME [kVA]</th>
                                        <th style={{ color: "#356E35" }}>TIME [kVA]</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((log, index) => (

                                            <tr key={index}>
                                                <td>{indexOfFirstItem + index + 1}</td>

                                                <td
                                                    // className="text-primary text-decoration-none"
                                                    // style={{ cursor: "pointer" }}
                                                    // onClick={() => handleOpenModal(log)}
                                                >
                                                    {log.MTR}
                                                </td>

                                                <td>{log.DATET}</td>
                                                <td>{log.DAY}</td>
                                                <td>{log.NAME}</td>

                                                <td>{log.KWH_CUM}</td>
                                                <td>{log.ENG}</td>

                                                <td>{log.KW_MAX}</td>
                                                <td>{log.KW_MAX_DATE}</td>
                                                <td>{log.KW_MAX_TIME}</td>

                                                <td>{log.KVAH_CUM}</td>
                                                <td>{log.ENG_KVAH}</td>

                                                <td>{log.KVA_MAX}</td>
                                                <td>{log.KVA_MAX_DATE}</td>
                                                <td>{log.KVA_MAX_TIME}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="19">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>



                        <div className="d-flex justify-content-center my-3">
                            <button
                                className="btn btn-sm mx-1"
                                style={{
                                    backgroundColor: "#356E35",
                                    color: "white",
                                    border: "none",
                                }}
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>

                            {[...Array(totalPages).keys()].map((num) => (
                                <button
                                    key={num}
                                    className="btn btn-sm mx-1"
                                    style={{
                                        backgroundColor: currentPage === num + 1 ? "#356E35" : "transparent",
                                        color: currentPage === num + 1 ? "white" : "#356E35",
                                        border: `1px solid #356E35`,
                                    }}
                                    onClick={() => handlePageChange(num + 1)}
                                >
                                    {num + 1}
                                </button>
                            ))}

                            <button
                                className="btn btn-sm mx-1"
                                style={{
                                    backgroundColor: "#356E35",
                                    color: "white",
                                    border: "none",
                                }}
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>


                    </div>
                </div>

            </div>

        </>

    );
}